var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"report-bottom"},[_c('div',{staticClass:"report-bottom-content",class:{ 'report-bottom-content-thin': false }},[_c('p',{staticClass:"report-bottom-content-info"},[_vm._v("注：本报告仅供临床医生参考！")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }